<template>
  <div>
    <page-head
      :title="title"
      :btn-list="btnList"
      :show-back="false"
      @handleBtn="handleBtn"
    ></page-head>
    <div class="content">
      <div class="search">
        <i-form ref="search" :model="query">
          <row :gutter="80">
            <i-col span="6">
              <form-item label="不动产业务单号" prop="orderNO">
                <Input
                  v-model="query.orderNO"
                  clearable
                  placeholder="请输入产业务单号"
                />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="不动产单元号" prop="estateUnitNO">
                <Input
                  v-model="query.estateUnitNO"
                  clearable
                  placeholder="请输入不动产单元号"
                />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="收件人" prop="toUserName">
                <Input
                  v-model="query.toUserName"
                  clearable
                  placeholder="请输入收件人"
                />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="收件人手机号码" prop="toPhoneNO">
                <Input
                  v-model="query.toPhoneNO"
                  clearable
                  placeholder="请输入收件人手机号码"
                />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="邮寄状态" prop="expressStatus">
                <Select v-model="query.expressStatus" clearable>
                  <Option
                    v-for="item in typeList"
                    :key="item.index"
                    :value="item.index"
                    :label="item.type"
                  ></Option>
                </Select>
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="办理时间" prop="eventtime">
                <DatePicker
                  v-model="time"
                  class="time"
                  type="daterange"
                  placeholder="请选择办理时间"
                ></DatePicker>
              </form-item>
            </i-col>
          </row>
        </i-form>
      </div>
      <div class="table-data">
        <i-table
          :columns="tableHeader"
          :border="true"
          :loading="isLoading"
          :data="tableData"
          stripe
          ref="table"
          @on-row-dblclick="handleClickDetail"
        >
          <template slot-scope="{ row, index }" slot="action">
            <span @click="handleClickDetail(row)" class="action">[详情]</span>
          </template>
          <template slot-scope="{ row, index }" slot="expressStatus">
            <span :style="{ color: typeList[row.expressStatus].color }">{{
              row.expressStatus1
            }}</span>
          </template>
          <template slot-scope="{ row, index }" slot="view">
            <span @click.stop="clickPic(row)">[查看]</span>
          </template>
        </i-table>
        <preview-img
          :currentIndex="0"
          :imgArr="showPreview.list"
          v-if="showPreview.show"
          v-on:closePreview="closePreview"
        ></preview-img>
        <div class="page">
          <page
            :total="total"
            :current="pageNum"
            @on-change="pageChange"
            show-total
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageHead from "../../../components/head";
import PreviewImg from "../../../components/previewImg";
import api from "../../../api/index";
const { mailList, mailListExport } = api;
const MAILMAP = {
  0: {
    expressStatus1: "未邮寄",
  },
  1: {
    expressStatus1: "已邮寄",
  },
  2: {
    expressStatus1: "驳回",
  },
};
export default {
  name: "mailList",
  components: {
    pageHead,
    PreviewImg,
  },

  data() {
    return {
      checkMsg: "",
      checkedId: "",
      showCheckMsg: false,
      modalTitle: "",
      showPreview: {
        show: 0,
        list: [],
      }, //预览图片
      typeList: [
        {
          index: 0,
          type: "未邮寄",
          color: "#FF7743",
        },
        {
          index: 1,
          type: "已邮寄",
          color: "#46BA54",
        },
        {
          index: 2,
          type: "驳回",
          color: "#F33D3D",
        },
      ],
      query: {
        orderNO: "",
        estateUnitNO: "",
        expressStatus: "",
        toUserName: "",
        toPhoneNO: "",
        beginTime: "",
        endTime: "",
      },
      estateUnitNO: "",
      estateUnitNOList: [],
      status: "",
      info: {},
      time: "",
      isLoading: false,
      isBtbLoading: false,
      pageNum: 1,
      pageSize: 10,
      total: 0,
      title: "不动产证书邮寄列表",
      btnList: [
        {
          name: "重置",
          type: "reset",
        },
        {
          name: "查询",
          type: "search",
        },
        {
          name: "导出",
          type: "export",
        },
      ],
      tableHeader: [
        {
          title: "序号",
          type: "index",
          width: 100,
          align: "center",
        },
        {
          title: "不动产业务单号",
          key: "orderNO",
        },
        {
          title: "不动产单元号",
          key: "estateUnitNO",
        },
        {
          title: "收件人",
          key: "toUserName",
        },
        {
          title: "收件人手机号码",
          key: "toPhoneNO",
        },
        {
          title: "邮寄状态",
          slot: "expressStatus",
        },
        {
          title: "办理时间",
          key: "expressTime",
        },
        {
          title: "委托书",
          slot: "view",
        },
        {
          title: "操作",
          slot: "action",
        },
      ],
      tableData: [],
      selectedList: [],
      header: {
        token: window.sessionStorage.getItem("token"),
      },
    };
  },
  methods: {
    handleBtn(type) {
      if (type == "reset") {
        this.time = "";
        this.pageNum = 1;
        this.query.beginTime = "";
        this.query.endTime = "";
        this.$refs.search.resetFields();
        this.query.checkStatus = "";
        this.query.useStatus = "";
        this.getMailList();
      } else if (type == "search") {
        this.pageNum = 1;
        this.getMailList();
      } else if (type == "export") {
        let {
          orderNO,
          estateUnitNO,
          expressStatus,
          toUserName,
          toPhoneNO,
          beginTime,
          endTime,
        } = this.query;
        let url =
          mailListExport +
          "?orderNO=" +
          orderNO +
          "&estateUnitNO=" +
          estateUnitNO +
          "&expressStatus=" +
          expressStatus +
          "&toUserName=" +
          toUserName +
          "&toPhoneNO=" +
          toPhoneNO +
          "&beginTime=" +
          beginTime +
          "&endTime=" +
          endTime +
          "&token=" +
          this.header.token;

        console.log(url);
        window.open(url);
      }
    },
    closePreview() {
      console.log("========closePreview==========");
      this.showPreview.show = 0;
    },
    clickPic(val) {
      this.showPreview.list = [];
      console.log(val);
      this.showPreview.list.push({ isHeight: true, path: val.picUrl });
      this.showPreview.show = 1;
    },
    handleClickDetail(item) {
      this.$router.push({
        name: "mailListDetail",
        query: { orderNO: item.orderNO },
      });
    },
    pageChange(val) {
      this.pageNum = val;
      this.getMailList();
    },
    async getMailList() {
      this.isLoading = true;
      try {
        if (this.time[0]) {
          this.query.beginTime = this.$util.FormatDate(
            new Date(this.time[0]),
            "yyyy-MM-dd"
          );
          this.query.endTime = this.$util.FormatDate(
            new Date(this.time[1]),
            "yyyy-MM-dd"
          );
        }
        let res = await this.$post(mailList, {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          ...this.query,
        });
        console.log(this.query);

        let list = res.rows.map((item) => ({
          ...item,
          expressTime: item.expressTime ? item.expressTime.substr(0, 19) : "",
          ...MAILMAP[item.expressStatus != null ? +item.expressStatus : null],
        }));
        console.log(list);
        this.tableData = list;
        this.total = res.total;
      } finally {
        this.isLoading = false;
      }
    },
  },

  created() {
    this.getMailList();
  },
  mounted() {},
};
</script>

<style  scoped lang="less">
.content {
  margin: 20px;
}
.search {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  margin-bottom: 20px;
}

.label {
  width: 100px;
}
.time {
  width: 100%;
}
.table-data {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  min-height: calc(100vh - 450px);
  .page {
    width: 100%;
    margin-top: 10px;
    display: flex;
    justify-content: center;
  }
  .success {
    color: #ff7b44;
  }
  .action {
    color: #5e6d94;
    cursor: pointer;
    margin-right: 10px;
  }
}

.statistics {
  padding: 10px 0;
  text-align: right;
}

.estateTitle {
  color: #ff7b44;
  font-weight: bold;
}

.estateNO {
  color: #ff7b44;
  font-weight: 400;
  background: #ffefe9;
  margin: 0 15px 10px 0;
}
</style>